import { render, staticRenderFns } from "./ResalePropertyList.vue?vue&type=template&id=85f5d876&"
import script from "./ResalePropertyList.vue?vue&type=script&lang=js&"
export * from "./ResalePropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports